export const statusMeta = {
  not_required: { label: "Not required", tone: "neutral" },
  required: { label: "Pending", tone: "warning" },
  pending: { label: "Pending", tone: "warning" },
  not_started: { label: "Pending", tone: "warning" },
  in_progress: { label: "Pending", tone: "warning" },
  submitted: { label: "Pending", tone: "warning" },
  processing: { label: "Pending", tone: "warning" },
  syncing: { label: "Updating", tone: "warning" },
  sync_delayed: { label: "Sync delayed", tone: "warning" },
  verified: { label: "Approved", tone: "success" },
  review: { label: "Needs review", tone: "warning" },
  approved: { label: "Approved", tone: "success" },
  declined: { label: "Declined", tone: "danger" },
  failed: { label: "Failed", tone: "danger" },
  expired: { label: "Expired", tone: "danger" },
  cancelled: { label: "Cancelled", tone: "danger" },
};

const badgeLabels = {
  required: "Pending",
  pending: "Pending",
  not_started: "Pending",
  in_progress: "Pending",
  submitted: "Pending",
  processing: "Pending",
  syncing: "Updating",
  sync_delayed: "Sync Delayed",
  verified: "Approved",
  review: "Needs Review",
  approved: "Approved",
  declined: "Declined",
  failed: "Failed",
  expired: "Expired",
  cancelled: "Cancelled",
};

const statusTooltips = {
  not_required: "Identity verification has not been requested for this reservation.",
  required: "Identity verification is required and waiting for the guest to start.",
  not_started: "Identity verification is required and waiting for the guest to start.",
  pending: "Identity verification is waiting for the guest or verification provider to continue.",
  in_progress: "The guest has started identity verification but has not completed it.",
  submitted: "The guest submitted their identity information and it is waiting to be checked.",
  processing: "The guest submitted their identity information and the results are being processed.",
  syncing: "A reviewer decision was saved and RueBaRue is waiting for the verification provider to confirm the updated outcome.",
  sync_delayed: "The verification provider has not confirmed the latest reviewer decision yet. Open the verification to check the current outcome.",
  verified: "Identity verification is complete and approved.",
  approved: "Identity verification is complete and approved.",
  review: "Identity verification is complete and needs a property manager to review the results.",
  declined: "Identity verification is complete and was declined.",
  failed: "Identity verification could not be completed. Open the verification for details.",
  expired: "The identity verification session expired before the guest completed it.",
  cancelled: "The identity verification session was cancelled.",
};

export const badgeStatusMeta = Object.keys(statusMeta).reduce((meta, status) => {
  if (!badgeLabels[status]) return meta;
  return {
    ...meta,
    [status]: {
      ...statusMeta[status],
      label: badgeLabels[status],
    },
  };
}, {});

export const normalizeStatus = (value) => {
  const raw = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  const aliases = {
    need_review: "review",
    needs_review: "review",
    under_review: "review",
    not_needed: "not_required",
    verification_required: "required",
  };

  return aliases[raw] || raw || "not_required";
};

export const getVerificationTooltip = (status) => {
  const normalized = normalizeStatus(status);
  return statusTooltips[normalized] || "Identity verification status is unavailable.";
};

// UIkit parses tooltip values as option pairs, so use explicit title syntax.
export const getVerificationTooltipAttr = (status) => {
  const title = getVerificationTooltip(status);
  return `title: ${title}; pos: top;`;
};

export const getReservationStatus = (reservation, status) =>
  normalizeStatus(
      status?.identity_verification?.status ||
      status?.verification_status ||
      reservation?.verification_status ||
      reservation?.identity_verification?.status ||
      (reservation?.identity_verification_required ? "required" : "not_required"),
  );
